import { schema } from 'normalizr';

import { categories } from './category';

const boardgame = new schema.Entity('boardgames', {
  categories,
});

export const boardgames = new schema.Array(boardgame);

export default boardgame;
